import script from "./BaseNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseNavigator.vue?vue&type=script&setup=true&lang=js"

import "./BaseNavigator.vue?vue&type=style&index=0&id=f860fe44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f860fe44"]])

export default __exports__